import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { addUpdateBanner } from "../../actions";
import { beforeUpload, getBase64FromImage } from "../../utils/common.utils";
import { validateBanner, validateBannerOnChange } from "../../validators";
import { GET_CATEGORIES_ALL, GET_SELLER_ALL } from "../../constants";
import API from "../../utils/api";

export const useAddUpdateBannerHook = ({
   selectedBannerData = {},
   isModalOpen = false,
   isEdit = false,
   handleSubmit = () => { }
}) => {
   const intialBannerData = {
      banner_id: null,
      name: "",
      description: "",
      status: true,
      banner_image: {
         base64url: "",
         url: "",
         file: null,
      },
      redirection_type: null,
      redirection_data: [],
      categories: [],
      sort_order_by: 1
   }
   const [bannerData, setBannerData] = useState({})
   const [isLoading, setIsLoading] = useState(false);
   const [errorMessages, setErrorMessages] = useState({});
   const [bannerInputData, setBannerInputData] = useState({});
   const [searchText, setSearchText] = useState('');

   useEffect(() => {
      fetchCategories()
      fetchSellers()
   }, [])

   useEffect(() => {
      if (isEdit && isModalOpen) {
         setBannerData({
            ...selectedBannerData,
            banner_id: selectedBannerData.banner_id || "",
            name: selectedBannerData.name || "",
            description: selectedBannerData.description || "",
            status: selectedBannerData.status || false,
            banner_image: {
               base64url: "",
               url: selectedBannerData.banner_url,
               file: null,
            },
            categories: [],
            sort_order_by: selectedBannerData.sort_order_by
         })
         setErrorMessages({})
      } else {
         setBannerData({ ...intialBannerData })
         setErrorMessages({})
      }
   }, [selectedBannerData, isModalOpen])

   const handleInputChange = (event) => {
      const { name, value } = event.target
      const errors = validateBannerOnChange(name, value, errorMessages)
      setErrorMessages({ ...errors })
      setBannerData({
         ...bannerData,
         [name]: value
      })
   }

   const handleSelectChange = (selectedValue, name) => {
      console.log({ selectedValue });
      const errors = validateBannerOnChange(name, selectedValue, errorMessages)
      
      // let selectedValues = bannerData[name].includes(selectedValue) ? [ ...bannerData[name], ...selectedValue ] : selectedValue

      setErrorMessages({ ...errors })
      if (name === "redirection_type") {
         setBannerData({
            ...bannerData,
            redirection_data: [], // Set redirection_data to an empty array
            [name]: selectedValue // Update redirection_type with the new value
         });
      } else {
         setBannerData({
            ...bannerData,
            [name]: selectedValue
         });
      }
   }

   const handleSwitchChange = (selectedValue, name) => {
      const errors = validateBannerOnChange(name, selectedValue, errorMessages)
      setErrorMessages({ ...errors })
      setBannerData({
         ...bannerData,
         [name]: selectedValue
      })
   }

   const handleUploadImage = async (event) => {
      try {
         const file = event.file;
         const isValidImage = beforeUpload(file.originFileObj)
         if (!isValidImage) {
            return;
         }

         const imageData = {
            base64url: await getBase64FromImage(file.originFileObj),
            file: file.originFileObj,
            url: ""
         }

         setBannerData({
            ...bannerData,
            banner_image: imageData
         })
         setErrorMessages({ ...errors, banner_image: "" })
      } catch (error) {
         console.log({ error });
      }
   };

   const handleRemoveImage = () => {
      const errors = validateBannerOnChange("banner_image", "", errorMessages)
      setErrorMessages({ ...errors })
      setBannerData({
         ...bannerData,
         banner_image: { ...intialBannerData.banner_image }
      })
   }

   const handleBannerSubmit = async () => {
      try {
         const errors = validateBanner(bannerData)
         setErrorMessages(errors)

         if (Object.keys(errors).length > 0) {
            return;
         }

         setIsLoading(true)
         const bannerPayload = {
            banner_id: selectedBannerData.banner_id,
            name: bannerData.name || "",
            description: bannerData.description || "",
            status: bannerData.status ? bannerData.status.toString() : null,
            sort_order_by: bannerData.sort_order_by || 1,
            redirection_type: bannerData.redirection_type,
            redirection_data: bannerData.redirection_data ? bannerData.redirection_data.toString() : null,
         }

         if (bannerData.banner_image && bannerData.banner_image.base64url) {
            bannerPayload.banner_image = bannerData.banner_image.base64url || ""
         }
         console.log(bannerPayload, "::bannerPayload")
         const bannerRes = await addUpdateBanner(bannerPayload)
         toast.success("banner status updated.")

         handleSubmit()
      } catch (error) {
         console.log({
            error
         });
         toast.error("Error while submiting banner data.")
      } finally {
         setIsLoading(false)
      }
   }

   const fetchCategories = async () => {
      try {
         await API.get(GET_CATEGORIES_ALL).then(async (result) => {
            const categoryData = await result.data.ResponseData.map((item) => ({
               label: item.category_name,
               value: item.category_id,
            }));
            setBannerInputData((prevInputData) => ({ ...prevInputData, categoryData: categoryData }))
         }).catch((err) => {
            console.log({ err });
         })
      } catch (error) {
         console.log({
            error
         });
         toast.error("Error while submiting banner data.")
      } finally {
         setIsLoading(false)
      }
   }

   const handleSearchChange = (event) => {
      const { name, value } = event?.target;
      console.log({name, value})
      // setSearchText(value);
      fetchSellers(value)
      // setTimeout(() => {
      // }, 500)
    };

    
   const fetchSellers = async (searchText = '') => {
      try {
         console.log({searchText:searchText})
         await API.get(GET_SELLER_ALL+`?search_text=${searchText}`).then(async (result) => {
            const sellerData = await result.data.ResponseData.map((item) => ({
               label: item.business_name,
               value: item.seller_id,
            }));

            console.log({sellerData:sellerData})
            setBannerInputData((prevInputData) => ({ ...prevInputData, sellerData: sellerData }))
         }).catch((err) => {
            console.log({ err });
         })
      } catch (error) {
         console.log({
            error
         });
         toast.error("Error while submiting banner data.")
      } finally {
         setIsLoading(false)
      }
   }

   return {
      isLoading,
      bannerData,
      errorMessages,
      bannerInputData,
      fetchSellers,
      handleSearchChange,
      handleInputChange,
      handleSelectChange,
      handleSwitchChange,
      handleBannerSubmit,
      handleUploadImage,
      handleRemoveImage
   }
}